import React from 'react';
import { FiStar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const reviews = [
  {
    author: "J. Miller",
    gear: "Apex Hardshell",
    text: "Survived a 3-day blizzard on Denali. The zippers didn't freeze, and the shell stopped 60mph winds dead. Worth every penny."
  },
  {
    author: "S. Carter",
    gear: "Polaris Bag",
    text: "Slept through a -15°F night in the Tetons wearing only base layers. The draft collar is incredibly well engineered."
  },
  {
    author: "E. Vance",
    gear: "Titanium Pack",
    text: "Hauled 65lbs of gear over 40 miles of scree. The suspension system saved my back. Fabric shows zero wear."
  }
];

const Reviews = () => {
  return (
    <section className="py-20 bg-zinc-900 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl font-black uppercase tracking-tighter mb-10 text-center">
          Field <span className="text-orange-500">Reports</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((rev, idx) => (
            <div key={idx} className="bg-zinc-950 border border-zinc-800 p-8 flex flex-col justify-between">
              <div>
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="w-4 h-4 text-orange-500 fill-orange-500" />
                  ))}
                </div>
                <p className="text-zinc-300 mb-6 italic leading-relaxed">"{rev.text}"</p>
              </div>
              <div className="border-t border-zinc-800 pt-4 mt-auto">
                <p className="font-black uppercase tracking-wider">{rev.author}</p>
                <p className="text-sm text-zinc-500 font-bold uppercase tracking-widest">Gear: {rev.gear}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;